import { useEffect, useState } from "react";
import useFacility from "../../../../../utils/hooks/useFacility";
import { Ticket } from "../../../../models/Ticket";
import { GET_USER_SELECTS_URL } from "../../../../api/apiRoutes";
import { get } from "../../../../api";
import { setErrors } from "../../../../store/alerts/alertsActions";
import { useDispatch } from "react-redux";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(false);

  const getTickets = async () => {
    setLoading(true);
    const { result, isError, errorTable } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setTickets(result);
    } else {
      dispatch(setErrors(errorTable));
    }
    setLoading(false);
  };

  useEffect(() => {
    getTickets();
    console.log(tickets)
    //eslint-disable-next-line
  }, []);

  const refreshTickets = () => {
    getTickets();
  };

  return { tickets, loading, refreshTickets };
};
